module.exports = __webpack_public_path__ + "img/ADBE.df5afa85.png";